import {view, StripeLogo, Divider} from '@sail/ui';
import {Link, Text} from 'src/v2/components/common';
import {defineMessages, FormattedMessage} from 'react-intl';
import {COLORS} from 'src/v2/util/color';

const messages = defineMessages({
  poweredByStripe: {
    id: 'crypto.payins.v2.footer.powered_by_stripe',
    description: 'Text indicating that the page is built by Stripe',
    defaultMessage: 'Powered by {stripeLogo}',
  },
  terms: {
    id: 'crypto.payins.v2.footer.terms',
    description: 'Link to the Stripe terms of service',
    defaultMessage: 'Terms',
  },
  privacy: {
    id: 'crypto.payins.v2.footer.privacy',
    description: 'Link to the Stripe privacy policy',
    defaultMessage: 'Privacy',
  },
});

export const Footer = () => {
  return (
    <view.div
      css={{
        stack: 'x',
        height: 'fit',
        distributeX: 'space-between',
        alignY: 'center',
        padding: '0 24px',
        gap: 'medium',
      }}
      data-testid="v2-footer"
    >
      <Link
        href="https://stripe.com"
        type="primary"
        target="_blank"
        css={{stack: 'x', alignY: 'center'}}
      >
        <Text type="caption" css={{color: COLORS.textDisabled}}>
          <FormattedMessage
            {...messages.poweredByStripe}
            values={{
              stripeLogo: (
                <StripeLogo
                  css={{
                    height: 'medium',
                    verticalAlign: 'middle',
                  }}
                />
              ),
            }}
          />
        </Text>
      </Link>
      <Divider />
      <view.div css={{stack: 'x', gap: 'small'}}>
        <Link
          href="https://stripe.com/legal/consumer"
          type="secondary"
          target="_blank"
          css={{stack: 'x', alignY: 'center'}}
        >
          <Text type="caption" css={{color: COLORS.textDisabled}}>
            <FormattedMessage {...messages.terms} />
          </Text>
        </Link>
        <Link
          href="https://stripe.com/privacy"
          type="secondary"
          target="_blank"
          css={{stack: 'x', alignY: 'center'}}
        >
          <Text type="caption" css={{color: COLORS.textDisabled}}>
            <FormattedMessage {...messages.privacy} />
          </Text>
        </Link>
      </view.div>
    </view.div>
  );
};
